import { useMutation } from '@apollo/client';
import { PROFESSIONAL_CREATE_TREATMENT_ADVICE, PROFESSIONAL_DELETE_TREATMENT_ADVICE, PROFESSIONAL_UPDATE_TREATMENT_ADVICE } from '../../services/graphql/mutations/professional';
import { useCallback } from 'react';

export const useCreateTreatmentAdvice = () => {
  const [createTreatmentAdvice, { loading }] = useMutation(PROFESSIONAL_CREATE_TREATMENT_ADVICE);

  const createData = useCallback(async (values: any) => {
    try {
      const { data } = await createTreatmentAdvice({
        variables: {
          input: {
            params: {
              clientId: values?.clientId,
              content: values?.content
            }
          },
        }
      });
      return data;
    } catch (error) {
      console.log('Error in createTreatmentAdvice: ', error);
    }
  }, [createTreatmentAdvice]);

  return {
    create: createData,
    loading
  };
};

export const useUpdateTreatmentAdvice = () => {
  const [updateTreatmentAdvice, { loading }] = useMutation(PROFESSIONAL_UPDATE_TREATMENT_ADVICE);

  const updateData = useCallback(async (values: any) => {
    console.log('updateData', values);
    try {
      const { data } = await updateTreatmentAdvice({
        variables: {
          input: {
            params: {
              id: values.id,
              content: values.content,
            },
          },
        }
      });
      return data;
    } catch (error) {
      console.log('Error in updateTreatmentAdvice: ', error);
    }
  }, [updateTreatmentAdvice]);

  return {
    update: updateData,
    loading
  };
};

export const useDeleteTreatmentAdvice = () => {
  const [deleteTreatmentAdvice, { loading }] = useMutation(PROFESSIONAL_DELETE_TREATMENT_ADVICE);

  const deleteData = useCallback(async (id: string) => {
    try {
      const { data } = await deleteTreatmentAdvice({
        variables: {
          input: {
            id
          },
        }
      });
      return data;
    } catch (error) {
      console.log('Error in deleteTreatmentAdvice: ', error);
    }
  }, [deleteTreatmentAdvice]);

  return {
    delete: deleteData,
    loading
  };
};